import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import './styles.css';
import { initializeErrorReporting } from './lib/error-reporting';
import { initializeAnalytics } from './lib/analytics';
import { initializePerformanceMonitoring } from './lib/performance-monitoring';

// Initialize production monitoring
const version = '0.1.0'; // Update from package.json
const environment = import.meta.env.MODE === 'production' ? 'production' : 'development';
const shouldRegisterServiceWorker = import.meta.env.PROD;

initializeErrorReporting(version, environment);
initializePerformanceMonitoring();
initializeAnalytics({
  appName: 'FlatRatePro',
  environment,
});

// Keep dev/test sessions free of stale cached assets from the production PWA worker.
if ('serviceWorker' in navigator) {
  if (shouldRegisterServiceWorker) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/frp/service-worker.js', { scope: '/frp/', updateViaCache: 'none' })
        .then((registration) => {
          console.log('Service worker registered:', registration);
          // Check for updates periodically
          setInterval(() => {
            void registration.update().catch(error => console.warn('Service worker update failed:', error));
          }, 60000);
        })
        .catch((error) => {
          console.error('Service worker registration failed:', error);
        });
    });
  } else {
    void navigator.serviceWorker.getRegistrations().then(async (registrations) => {
      await Promise.all(registrations.filter(registration =>
        new URL(registration.scope).pathname === '/frp/'
      ).map((registration) => registration.unregister()));

      if ('caches' in window) {
        const cacheKeys = await caches.keys();
        await Promise.all(cacheKeys.filter(key => key.startsWith('frp-shell-') || /^frp-v\d+$/.test(key))
          .map((cacheKey) => caches.delete(cacheKey)));
      }
    }).catch(error => console.error('Development PWA cleanup failed:', error));
  }
}

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('FlatRate Pro root element was not found.');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
